// @flow

import * as React from 'react';
import {useAccount} from 'docs/data';
import ObjectDisplay from './ObjectDisplay';
import {buildDefaultRenderValue} from './helpers';

import './CollapsibleJson.scss';

type Props = {
  data: Object,
  minCollapseSize?: number,
  renderValue?: (any) => React.Node,
};

const CollapsibleJson = ({data, minCollapseSize = 1, renderValue}: Props) => {
  const {account} = useAccount();

  const defaultRenderValue = buildDefaultRenderValue({
    dashboardHost: account.hosts['dashboard.stripe.com'],
  });

  return (
    <div className="CollapsibleJson">
      <ObjectDisplay
        data={data}
        isRoot
        minCollapseSize={minCollapseSize}
        renderValue={renderValue ?? defaultRenderValue}
      />
    </div>
  );
};

export default CollapsibleJson;
